<template>
<div>
	<header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">เกี่ยวกับ Quick Reply</h1>
    </header>


<div class="MarkdownContent hidden-sm-and-down" style="width: 70vw;">


<v-layout row wrap>
      <v-flex xl3 lg3 md3 style="text-align: center;">
    <div style="text-align: center;">
      <img src="/static/bot component/quickreply/quickreply about.gif" style="width: 170px;" />
    </div>
  </v-flex>
        <v-flex xl9 lg9 md9 style="text-align: left;">
      <br>
      <br>
      <p class="preindent" style="width: 70%; margin-top: 40px;">Quick Reply เป็นตัวช่วยแนะนำคำที่สามารถ reply กลับหาบอทได้ เช่น คำว่า "ลงทะเบียน", "โปรโมชั่น" หรือ "เปิดไฟ" เป็นต้น
      </p>
      <p class="preindent" style="width: 70%;"> นอกจาก quick reply ประเภทข้อความแล้ว ยังมีquick reply ประเภทวัน วันเวลา เว็บวิวและลิงก์ อีกด้วย สามารถนำไปประยุกต์กับงานได้หลากหลายมากขึ้น ตัวอย่างเช่น งานด้าน IoT, งานขายทั่วไป, การนัดหมาย หรือ งานที่ต้องการข้อมูลเพื่อนำไปวิเคราะห์ เป็นต้น </p>
      <p class="preindent" style="width: 70%;"> หมายเหตุ: เมื่อมีการกดเลือกหรือมีข้อความใดแทรกเข้ามา จะทำให้แถบ quick reply ในหน้าแชทของผู้ใช้หายไป</p>
  </v-flex>
</v-layout>
</div>

<div class="MarkdownContent hidden-md-and-up">
      <p class="preindent">Quick Reply เป็นตัวช่วยแนะนำคำที่สามารถ reply กลับหาบอทได้ เช่น คำว่า "ลงทะเบียน", "โปรโมชั่น" หรือ "เปิดไฟ" เป็นต้น </p>
      <p class="preindent"> นอกจาก quick reply ประเภทข้อความแล้ว ยังมีquick reply ประเภทวัน วันเวลา เว็บวิวและลิงก์ อีกด้วย สามารถนำไปประยุกต์กับงานได้หลากหลายมากขึ้น ตัวอย่างเช่น งานด้าน IoT, งานขายทั่วไป, การนัดหมาย หรือ งานที่ต้องการข้อมูลเพื่อนำไปวิเคราะห์ เป็นต้น </p>
      <p class="preindent"> หมายเหตุ: เมื่อมีการกดเลือกหรือมีข้อความใดแทรกเข้ามา จะทำให้แถบ quick reply ในหน้าแชทของผู้ใช้หายไป</p>
    </div>

<div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/bot component/quickreply/quickreply about.gif" style="width: 70vw;" />
    </div>












<header class="EndpointHeader">
    <h2 class="EndpointTitle"> API Quick Reply </h2>
    -
    <span class="EndpointVerbPost"> POST </span>
    <span class="EndpointUrl">
      {{urlsendQuickreply}}
      <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendQuickreply">file_copy</v-icon>
    </span>
  </header>


  <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
    <h3>Request Parameter (JSON)</h3>
    <code class="codecolor">
      <v-tooltip top>
        <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
        <span>Copy to clipboard</span>
      </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"โปรดเลือกอาหารที่คุณชอบมากที่สุด"</span>,
    <span class="colorkey">"quick_reply"</span> : [ {....รูปแบบquick replyต่างๆ....} ]
  }
    </code>

    <table id="apimsgtable" style="margin-top: 2vh;">
      <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td>รหัสเฉพาะของบอท</td>
      </tr>
      <tr>
        <td>message</td>
        <td>String</td>
        <td>ข้อความปกติที่ขึ้นในหน้าแชท คล้ายการ push_message ประเภท text นำมาใช้เพื่อเป็นคำถามหรือแนะนำquick replyแต่ละปุ่ม</td>
      </tr>
      <tr>
        <td>quick_reply</td>
        <td>List [length<=11]</td>
        <td>ข้อมูลแต่ละปุ่มของ quick reply ซึ่งจะประกอบด้วยข้อมูลที่เป็น Dictionary(json) สามารถเลือกดูไปตามลิงด้านล่าง
        </td>
      </tr>
    </table>
  </div>

<div class="MarkdownContent hidden-md-and-up">
    <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
    <h3>Request Parameter (JSON)</h3>
    <code class="codecolormo">
      <v-tooltip top>
        <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
        <span>Copy to clipboard</span>
      </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"โปรดเลือกอาหารที่คุณชอบมากที่สุด"</span>,
    <span class="colorkey">"quick_reply"</span> : [ {....รูปแบบquick replyต่างๆ....} ]
  }
    </code>

    <table id="apimsgtablemo" style="margin-top: 2vh;">
      <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td>รหัสเฉพาะของบอท</td>
      </tr>
      <tr>
        <td>message</td>
        <td>String</td>
        <td>ข้อความปกติที่ขึ้นในหน้าแชท คล้ายการ push_message ประเภท text นำมาใช้เพื่อเป็นคำถามหรือแนะนำquick replyแต่ละปุ่ม</td>
      </tr>
      <tr>
        <td>quick_reply</td>
        <td>List [length<=11]</td>
        <td>ข้อมูลแต่ละปุ่มของ quick reply ซึ่งจะประกอบด้วยข้อมูลที่เป็น Dictionary(json) สามารถเลือกดูไปตามลิงด้านล่าง
        </td>
      </tr>
    </table>
  </div>



<br>
    รูปแบบและประเภทของquick reply
    <ul v-if="path == '/develop/docs/quickreply/aboutquickreply'">
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_text')">ประเภทข้อความ</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_link')">ประเภทลิงก์</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_webview')">ประเภทเว็บวิว</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_datepicker')">ประเภทวัน</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_datetimepicker')">ประเภทวันเวลา</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_location')">ประเภทโลเคชัน</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_image')">ประเภทรูปภาพ</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_file')">ประเภทไฟล์</a></li>
      <li><a  @click="toPage('/develop/docs/quickreply/quickreply_ocr')">ประเภท OCR</a></li>
    </ul>
    <ul v-else>
      <li><a  @click="toPage('/docs/quickreply/quickreply_text')">ประเภทข้อความ</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_link')">ประเภทลิงก์</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_webview')">ประเภทเว็บวิว</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_datepicker')">ประเภทวัน</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_datetimepicker')">ประเภทวันเวลา</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_location')">ประเภทโลเคชัน</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_image')">ประเภทรูปภาพ</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_file')">ประเภทไฟล์</a></li>
      <li><a  @click="toPage('/docs/quickreply/quickreply_ocr')">ประเภท OCR</a></li>
    </ul>
  </div>
</template>
<script>
export default {
  data: () => ({
    path: '',
    urlsendQuickreply: '',
    message: '{\n\t"to": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"message": "โปรดเลือกอาหารที่คุณชอบมากที่สุด",\n\t"quick_reply": [ {....รูปแบบquick replyต่างๆ....} ]\n}'
  }),
  methods: {
    toPage (page) {
      this.$router.push(page)
    }
  },
  created () {
    this.path = this.$router.currentRoute.path
    this.urlsendQuickreply = process.env.APIquickreply + '/api/v1/push_quickreply'
    // this.urlsendQuickreply = process.env.APIimage + '/api/v1/push_quickreply'
  }
}
</script>

<style type="text/css">
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/quickreply/aboutQuickReply.vue